import React from 'react'
import { DomParser } from './domParser'
import dynamic from 'next/dynamic'

const Videos = dynamic(() => import('../../components/video/Videos').then(mod => mod.Videos))

export const iframe: DomParser = (element, props) => (
  <Videos videos={[{ videoSource: props.src as string }]} ncol={0} />
)